/* global document */

import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

import LoggedIn from './loginWidget/LoggedIn';
import NotLoggedIn from './loginWidget/NotLoggedIn';

const LoginWidget = () => {
  const customerReducer = useSelector((state) => state.customer);
  const { data: customer, isObjectFetching } = customerReducer;

  if (!customer && isObjectFetching) {
    return ReactDOM.createPortal(null, document.getElementById('c7-account'));
  }

  if (customer) {
    return ReactDOM.createPortal(
      <LoggedIn />,
      document.getElementById('c7-account')
    );
  }

  return ReactDOM.createPortal(
    <NotLoggedIn />,
    document.getElementById('c7-account')
  );
};

export default LoginWidget;
